export function actionCue(type) {
  if (type === 'FOLD') return 'fold';
  if (['CALL', 'BET', 'RAISE'].includes(type)) return 'chip';
  return null;
}

export function atmosphereFor(state) {
  if (state.seats[0].stack < state.hardTimesBalance) return { id: 'hard-times', music: 'hard' };
  if (state.pot >= state.extremePot) return { id: 'pot-extreme', music: 'high' };
  if (state.pot >= Math.round(state.buyIn * 0.22)) return { id: 'pot-high', music: 'high' };
  if (state.pot >= Math.round(state.buyIn * 0.10)) return { id: 'pot-warm', music: 'base' };
  return { id: 'pot-calm', music: 'base' };
}
